import { useEffect, useState } from 'react';

/**
 * Efemer uzenetek - csak nekem, csak most.
 *
 * A slash parancs igy tud olyat valaszolni, ami csak a kerdezot erdekli
 * ("nincs ilyen allat"), anelkul hogy a csatornat teleszemetelne.
 *
 * SZANDEKOSAN nem a react-query gyorsitotaraban tarolodik: ezek nem szerver-
 * allapotot tukroznek, hanem mulandó jelzesek. Nincs mit ujratolteni, nincs
 * mit szinkronban tartani - egy perc mulva maguktol eltunnek.
 */

export interface EphemeralNote {
  id: string;
  channelId: string;
  source: string;
  text: string;
  createdAt: number;
}

const TTL_MS = 60_000;

let notes: EphemeralNote[] = [];
const listeners = new Set<(items: EphemeralNote[]) => void>();
let counter = 0;

function emit(): void {
  for (const listener of listeners) listener(notes);
}

export function pushEphemeral(channelId: string, source: string, text: string): void {
  counter += 1;
  const note: EphemeralNote = {
    id: `eph-${counter}`,
    channelId,
    source,
    text,
    createdAt: Date.now(),
  };

  notes = [...notes, note];
  emit();

  setTimeout(() => {
    notes = notes.filter((item) => item.id !== note.id);
    emit();
  }, TTL_MS);
}

export function dismissEphemeral(id: string): void {
  notes = notes.filter((item) => item.id !== id);
  emit();
}

export function useEphemeral(channelId: string): EphemeralNote[] {
  const [items, setItems] = useState<EphemeralNote[]>(notes);

  useEffect(() => {
    listeners.add(setItems);
    return () => {
      listeners.delete(setItems);
    };
  }, []);

  return items.filter((item) => item.channelId === channelId);
}
